/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
export * from "./Capabilities";
export * from "./RenderCompatibility";

/** @docs-package-description
 * The webgl-compatibility package provides APIs for determining the level of compatibility of a browser and device with the iTwin.js rendering system.
 *
 * This package is used by the [iTwin.js Compatibility Checker website](https://itwinjscompatibility.bentley.com/) to evaluate whether
 * a user's browser and hardware meet the requirements for running iTwin.js applications.
 */

/**
 * @docs-group-description Compatibility
 * APIs for evaluating compatibility with the iTwin.js rendering system.
 */
